var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Portal',{attrs:{"to":_vm.teleportTo,"disabled":!_vm.teleportTo}},[_c('div',{ref:"observeDiv",staticClass:"applepay-button",attrs:{"id":"applepay-button"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }